<template>
  <f7-page class="main-frmordencarga">
    <template #fixed>
      <TheNavbar
        style="--f7-navbar-bg-color: var(--his-slate-blue);"
        :nav-title="$t('commercialization.common.newExpedition')"
        back-btn-enable
      >
        <!-- Slot nos permite añadir iconos en el navbar que que queremos no el original -->
        <template #btn-right>
          <f7-link
            @click="NavigateToNewExpedition()"
          >
            <f7-icon
              icon="icon-addNew"
            />
          </f7-link>
        </template>
      </TheNavbar>
    </template>

    <f7-block class="main-worker-records no-margin padding bloque-busqueda block">
      <!-- <UCSearchEntityERP
        ref="UCLicenceComponent"
        placeholder="Matricula del camión "
        search-text="Buscando la matricula"
        search-cancellation-text="Búsqueda de matricula cancelada…"
        search-not-found-text="matricula no encontrado…"
        :property-entity-shown-input="['Matricula']"
        :property-entity-shown-list-title="['Matricula']"
        :property-entity-shown-list-subtitle="['Matricula']"
        :next-and-previous-buttons-shown="false"
        :default-etities-list="matriculas"
        @selection="EventLicenseSelected"
      /> -->
      <UCSearchEntityERP
        :title="$t('common.registration')"
        :placeholder="$t('searchEntity.plate.placeholder.searchByPlate')"
        :search-text="$t('searchEntity.plate.searchText')"
        :search-cancellation-text="$t('searchEntity.plate.searchCancellationText')"
        :search-not-found-text="$t('searchEntity.plate.searchNotFoundText')"
        :end-point-for-code-search="GetPlatesByCode"
        :end-point-for-list="GetPlates"
        :property-entity-shown-input="['Matricula', 'Descripcion']"
        :property-entity-shown-list-title="['Matricula']"
        :property-entity-shown-list-subtitle="['Descripcion']"
        :min-text-search="0"
        :autofocus-on-deselection="true"
        :auto-focus-on-empty-search-result="true"
        @selection="EventLicenseSelected"
      />
    </f7-block>
    <UCEmptyList
      v-if="licenseSelected == null"
      class="emptyList"
    >
      <template #btn-add>
        <span class="emptyList line1">{{ $t('commercialization.common.noPlannedLoads') }}</span>
        <div class="emptyList line2">
          {{ $t('common.pleasePress') }}
          <img
            class="btnAdd"
            src="@/static/icons/ic_add_new.svg"
          >
          <span>{{ $t('commercialization.common.toPlanLoadingForVehicle') }}</span>
        </div>
      </template>
    </UCEmptyList>
    <div
      v-if="selectedExpedition != null"
      class="list accordion-list display-flex flex-direction-column"
    >
      <ul
        v-for="(items, index) in selectedExpedition.Lineas"
        :key="index"
      >
        <li
          class="accordion-item"
        >
          {{ totalPallets }}
          <div>
            <a
              class=" item-link"
              href="#"
            >
              <div>
                <f7-row>
                  <f7-col
                    width="60"
                    class="padding-left"
                  >
                    <span class="title1">{{ items.Cliente.Nombre }}</span>
                    <br>
                    <span class="title2">{{ `${items.Orden} - ${items.Producto.Nombre}` }}</span>
                    <br>
                    <span class="title3">{{ `${items.Envase.Nombre} ${items.Formato}` }}  </span>
                  </f7-col>
                  <f7-col width="40">
                    <f7-card class="palets">
                      <span class="textPalets">{{ $t('common.pallets').toUpperCase() }}</span>
                      <span class="title4">{{ items.CantidadTotalPales }} </span>
                    </f7-card>
                  </f7-col>
                </f7-row>
              </div>
              <!-- <f7-list media-list>
                <f7-list-item>
                  <template #title>
                    <div>
                      <div class="main-title">
                        {{ items.Cliente }}
                      </div>
                    </div>
                  </template>

                  <template #subtitle>
                    <div>
                      <div class="title2">
                        {{ `${items.Orden} - ${items.Articulo}` }}
                      </div>
                    </div>
                  </template>

                  <template #text>
                    <div>
                      <div class="title3">
                        {{ `${items.Cantidad} ${items.Formato}` }}
                      </div>
                    </div>
                  </template>

                  <template #after>
                    <div>
                      <div class="palets">
                        {{ $t('common.pallets').toUpperCase() }}
                        <span class="title4">{{ items.PaletsCargados }} </span>
                      </div>
                    </div>
                  </template>
                </f7-list-item>
              </f7-list> -->
            </a>
            <div class="accordion-item-content display-flex">
              <div class="block padding-left ">
                <span> {{ $t('commercialization.common.totalPendingPallets') }} </span>
                <br>
                <span class="number"> {{ items.CantidadTotalPales }} </span>
              </div>

              <div class="col padding-left text-align-center">
                <span> {{ $t('common.quantity').toUpperCase() }} </span>
                <br>
                <div class="stepper stepper-fill stepper-init">
                  <f7-stepper
                    fill
                    :value="getValue(items)"
                    :min="getValue(items)"
                    :max="getMax(items)"
                    @input="valorInput = $event.target.value"
                    @stepper:change="ChangeNumberPallets(items.Lineas)"
                  />
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- Popup Search expedicion -->
    <f7-popup
      class="Search-popup"
      :opened="popupExpeditions"
      @popup:closed="popupExpeditions = false"
    >
      <f7-page>
        <f7-navbar
          class="at-navbar secondary-navbar"
          :title="$t('commercialization.common.selectAnExpedition')"
        >
          <f7-nav-right>
            <f7-link
              popup-close
              icon="icon-close"
              @click="popupExpeditions = false"
            />
          </f7-nav-right>
        </f7-navbar>
        <f7-list
          class="search-list searchbar-found"
        >
          <f7-list-item
            v-for="entity in expeditions"
            :key="entity.Numero"
            :title="entity.Serie"
            @click="popupExpeditions = false;SelectEntity(entity)"
          />
        </f7-list>
      </f7-page>
    </f7-popup>
    <div class="btns">
      <f7-button
        v-if="licenseSelected != null"
        fill
        class="btn-Siguiente"
        @click="Siguiente()"
      >
        {{ $t('common.next') }}
      </f7-button>
    </div>
  </f7-page>
</template>

<script>
import { mapState } from 'pinia';
import { useAppConfigStore } from '@/js/stores/appConfig';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import TheNavbar from '@/components/TheNavbar.vue';
import APIErp from '@/js/services/APIErp';
import UCEmptyList from '@/components/common/UCEmptyList.vue';
import { f7 } from 'framework7-vue';

export default {
  name: 'FrmExpeditionDocumentNew',
  components: {
    UCSearchEntityERP,
    TheNavbar,
    UCEmptyList,
  },
  props: {
    totalPallets: { type: Number, default: null },
    // loadedPallets: { type: String, default: null },
  },

  emits: ['new-data'],

  data() {
    return {
      licenseSelected: null,
      matricula: null,
      expeditions: null,
      selectedExpedition: null,
      popupExpeditions: null,

    };
  },

  computed: {
    ...mapState(useAppConfigStore, ['userEnviroment']),
  },

  created() {
    this.Conections_GetAvailablePlates();
  },

  methods: {
    NavigateToNewExpedition() {
      Log(this, this.NavigateToNewExpedition.name);
      f7.views.main.router.navigate('/commercialisation/expedition/frmExpeditionEditLines');
    },
    Siguiente() {
      Log(this, this.Siguiente.name);
      const exp = [this.selectedExpedition];
      f7.views.main.router.navigate('/commercialisation/expedition/frmExpeditionDocumentCompleteData/', {
        props: {
          expeditionDocument: exp,
        },
      });
    },

    // ChangeNumberPallets(value) {
    //   Log(this, this.ChangeNumberPallets.name);
    //   this.newPalletsLoaded = value;

    //   for (let i = 0; i < this.datos.length; i += 1) {
    //     const dataList = this.datos[i].items;
    //     for (let j = 0; j < dataList.length; j += 1) {
    //       if (dataList[j].Matricula === this.licenseSelected) {
    //         this.loadedPallets = dataList[j].PaletsCargados;
    //         this.totaLoadedPallets = dataList[j].PaletsTotalesCargar;
    //       }
    //     }
    //   }

    //   Number(this.loadedPallets);
    //   Number(this.totaLoadedPallets);
    // },
    ChangeNumberPallets(items) {
      Log(this, this.ChangeNumberPallets.name);

      this.selectedExpedition.Lineas.forEach((e) => {
        if (e.Id === items.Id) {
          e.PaletsCargados = this.valorInput;
        }
      });
      this.NewData(this.selectedExpedition);
    },

    NewData(newData) {
      Log(this, this.NewData.name);
      this.$emit('new-data', newData);
    },

    SelectEntity(obj) {
      this.selectedExpedition = obj;
    },
    EventLicenseSelected(objLicense) {
      if (objLicense != null) {
        this.licenseSelected = objLicense.Item;
        this.Conections_GetExpeditions(this.licenseSelected);
      } else {
        this.licenseSelected = null;
        this.selectedExpedition = null;
      }
    },
    getValue(items) {
      Log(this, this.getValue.name);
      return Number(items.CantidadTotalPales);
    },

    getMax(items) {
      Log(this, this.getMax.name);
      return Number(items.CantidadTotalPales);
    },

    /* matriculas */
    /* GetPlates() {
      Log(this, this.GetPlates.name);
      const params = {
        Fecha: this.dateFilter,
      };
      return APIErp.callGetExpeditions(params);
    },
    GetPlatesByCode(code) {
      Log(this, this.GetPlatesByCode.name);
      const params = {
        Expedicion: {
          Matricula: code,
        },
      };
      return APIErp.callGetExpeditions(params);
    }, */

    GetPlates() {
      Log(this, this.GetPlates.name);
      return APIErp.callGetVehicle();
    },
    GetPlatesByCode(params) {
      Log(this, this.GetPlatesByCode.name);
      return APIErp.callGetVehicle(params);
    },

    Conections_GetAvailablePlates() {
      Log(this, this.Conections_GetAvailablePlates.name);
      const self = this;
      return new Promise((resolve, reject) => {
        APIErp.callGetVehicle()
          .then((result) => {
            self.matricula = result.data;
          }).catch((error) => {
            LogError(this, this.Conections_GetExpeditions.name, error);
            reject(error);
          });
      });
    },

    Conections_GetExpeditions(matricula) {
      Log(this, this.Conections_GetExpeditions.name);
      const self = this;
      const filtro = {};
      if (matricula !== null) {
        filtro.Matricula = matricula;
      }
      filtro.Centro = this.userEnviroment.EntornoDeTrabajo.Centro;
      return new Promise((resolve, reject) => {
        APIErp.callGetExpeditions(filtro)
          .then((result) => {
            self.expeditions = result.data;
            // this.OrderExpeditions();
            if (self.expeditions.length > 1) {
              self.popupExpeditions = true;
            } else {
              self.selectedExpedition = self.expeditions;
            }
          }).catch((error) => {
            LogError(this, this.Conections_GetExpeditions.name, error);
            reject(error);
          });
      });
    },
  },
};
</script>

<style lang="scss">
.main-frmordencarga {
  .accordion-list {
    background: #fff;

    .accordion-item {
      padding-top: 5px;
      padding-bottom: 5px;
      border: 0.5px solid var(--his-silver);

      .item-inner {
        border-radius: 4px;
        line-height: 16px;
        font-size: 14px;
        font-weight: 400;
      }
    }
  }

  .accordion-item-content {
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 18px;
    color: var(--his-steel-blue);
    background: var(--hi-lightsnow);

    .block {
      width: 60%;

      span {
        padding-left: 25px;
      }

      .number {
        font-weight: 500;
        font-size: 28px;
        line-height: 33px;
      }
    }

    .col {
      width: 40%;
    }
  }

  .title1 {
    font-size: 18px;
    font-weight: 500;
    color: var(--his-slate-blue);
  }

  .title2 {
    font-size: 14px;
    color: var(--his-oliva);
  }

  .title3 {
    font-size: 14px;
    color: var(--his-orange);
  }

  .title4 {
    font-size: 30px;
    line-height: 50px;
    color: var(--his-slate-blue);
  }

  .palets {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 60px;
    padding: 5px 4px;
    width: 56px;
    background: var(--hi-lightsnow);
    border-radius: 4px;
    line-height: 12px;

    .textPalets {
      font-weight: 500;
      font-size: 13px;
      color: #aaa1a1;
    }
  }

  .btn-Siguiente {
    width: 340px;
    height: 43px;
    border-radius: 3px;
    background-color: var(--his-orange);
    left: calc(50% - 340px / 2);
    top: calc(50% - 43px / 2 + 287.5px);
  }

  .emptyList {
    position: fixed;
    line-height: 26px;
    text-align: center;
    font-family: Roboto;
    font-style: normal;

    .line1 {
      width: 218px;
      height: 26px;
      left: 73px;
      top: 230px;
      font-weight: 500;
      font-size: 18px;
      color: #aaa1a1;
    }

    .line2 {
      width: 294px;
      height: 40px;
      left: 35px;
      top: 270px;
      font-weight: 300;
      font-size: 14px;
      color: var(--his-ash-gray);
    }

    .btnAdd {
      width: 15px;
      height: 15px;
      left: 120px;
      top: 273px;
    }
  }
}
</style>
